export default __webpack_public_path__ + "static/media/our_mission.b0e097c8.pdf";